import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from '@progress/kendo-file-saver';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslationKeys } from 'ph-bhp-localization';
import { ProfileService } from 'profile';

@Component({
  selector: 'app-migration-tool',
  templateUrl: './migration-tool.component.html',
  styleUrls: ['./migration-tool.component.css']
})
export class MigrationToolComponent implements OnInit {

  showPassword = false;
  formdata: UntypedFormGroup;
  admitedUserName: boolean = true;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  admitedChars = /^([A-Za-z0-9'.\-_!#\^~]+)$/;
  textAreaLogs = '';
  migrationGuid ='';
  migrationId = '';
  downloadDisabled = true;
  @ViewChild('logs') private logsContainer: ElementRef;


  constructor(private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private userDetailsService: ProfileService,
    public layoutService: PHBHPLayoutPackageService,
    private service: PHBHPApiService) { }

  ngOnInit() {
    this.formdata = new UntypedFormGroup({
      username: new UntypedFormControl('', Validators.compose([
        Validators.required
      ])),
      institutionid: new UntypedFormControl('', Validators.compose([
        Validators.required
      ])),
      password: new UntypedFormControl('', Validators.compose([
        Validators.required
      ])),
    })
  }

  viewPassword() {
    this.showPassword = !this.showPassword;
  }

  checkUserName(text) {

    if (!text) {
      this.admitedUserName = true;
      return;
    }

    if (text.match(this.admitedChars)) {
      this.admitedUserName = true;
    } else {
      this.admitedUserName = false;
    }
  }

  startMigration(event: Event) {

    event.stopPropagation();
    event.preventDefault();

    const username = this.formdata.get('username').value;
    const password = this.formdata.get('password').value;
    const institution = this.formdata.get('institutionid').value;
    this.layoutService.showLoader = true;
    this.service.getApi(`MigrationTool/MigrateV2toV3/${username}/${password}/${institution}`, true).subscribe(res => {
      if (res.started) {
        this.migrationGuid = res.fileGuidId;
        this.migrationId = res.migrationId;
        this.layoutService.showSuccess('Migration started');
        this.textAreaLogs = 'starting...'
        let id = setInterval(() => {
          this.service.getApi(`MigrationTool/ReadLogs/${res.migrationId}/N`, true).subscribe(res => {
            if (res.status.toLowerCase() == 'completed') {
              this.textAreaLogs = res.logs;
              this.logsContainer.nativeElement.scrollTop = this.logsContainer.nativeElement.scrollHeight;
              this.layoutService.showLoader = false;
              this.downloadDisabled = false;
              this.layoutService.showSuccess('Migration completed successfully!');
              clearInterval(id);
            } else if (res.status.toLowerCase() == "error") {
              this.textAreaLogs = res.logs;
              this.logsContainer.nativeElement.scrollTop = this.logsContainer.nativeElement.scrollHeight;
              this.layoutService.showLoader = false;
              this.downloadDisabled = false;
              this.layoutService.showError('Migration not completed. See the avobe logs for more info.');
              clearInterval(id);              
            } else {
              this.textAreaLogs = res.logs;
              this.logsContainer.nativeElement.scrollTop = this.logsContainer.nativeElement.scrollHeight;
              this.downloadDisabled = false;
            }
          }, err => {
            this.layoutService.showError('Error: '+err);
             this.layoutService.showLoader = false;
            clearInterval(id);
          });
        }, 15 * 1000);
      }else{
        this.layoutService.showError('Migration cannot start, cause: '+res.message);
        this.layoutService.showLoader = false;
      }
    }, err => {
      this.layoutService.showLoader = false;
      this.layoutService.showError('Error - '+err);
    });

    return

  }

  downloadLogs(event){
    event.stopPropagation();
    event.preventDefault();
    const institution = this.formdata.get('institutionid').value;
    this.service.getApi(`MigrationTool/ReadLogs/${this.migrationId}/Y`, true).subscribe(res => {
      const dataURI = 'data:text/plain;base64,' + res.logs;
      const fileName = this.getFileName(institution);
      saveAs(dataURI, `${fileName}.txt`);
    }, err=> {

    });
  }

  getFileName(institutionId) {
    const dateInfo = this.layoutService.getDateForFileName();
    return `${dateInfo}_${this.migrationId}_${institutionId}`;
  }

}